import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "./Header";
import Right from "./Right";
import { fetchProfileById } from "../../redux/profileSlice";

export default function Images() {
  const navigate = useNavigate();
  const location = useLocation();
  const profileId = location.state?.profileId;
  const dispatch = useDispatch();
  const [profileData, setProfileData] = useState(null);

  // fetch profile data on mount
  useEffect(() => {
    const fetchData = async () => {
      const action = await dispatch(fetchProfileById(profileId));
      setProfileData(action.payload);
    };
    fetchData();
  }, [dispatch, profileId]);

  useEffect(() => {
  console.log("PROFILE DATA 👉", profileData);
}, [profileData]);


  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div>
                {!profileData ? (
                  <div className="text-center py-5">
                    <div
                      className="spinner-border text-red-primary"
                      role="status"
                    />
                  </div>
                ) : profileData.images?.length === 0 ? (
                  <div className="alert alert-warning text-center">
                    No images available
                  </div>
                ) : (
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide"
                  >
                    <div className="carousel-indicators">
                      {profileData.images?.map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          data-bs-target="#carouselExampleIndicators"
                          data-bs-slide-to={index}
                          className={index === 0 ? "active" : ""}
                          aria-current={index === 0 ? "true" : undefined}
                          aria-label={`Slide ${index + 1}`}
                        ></button>
                      ))}
                    </div>

                    <div className="carousel-inner rounded-4">
                      {profileData.images?.map((img, index) => (
                        <div
                          key={index}
                          className={`carousel-item rounded-4 ${
                            index === 0 ? "active" : ""
                          }`}
                        >
                          <img
                            src={img.docUrl}
                            className="d-block w-100 rounded-4 object-fit-cover"
                            alt={`Slide ${index + 1}`}
                            height="600"
                          />
                        </div>
                      ))}
                    </div>

                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}
